import { nextTick } from 'vue';
import { freedomApp } from '../../entities/freedom-app';

export const handleSplashScreen = () => {
  nextTick(freedomApp.lib.closeSplashScreen);

  performance.mark('closeSplashScreen');
  // Sentry automatically collects data from Performance API and then send it as span inside the active transaction.
  performance.measure('SplashScreenClosingTime', 'start', 'closeSplashScreen');
};
